module.exports = __webpack_public_path__ + "img/20200106155809547.912ed2c6.jpg";